export const componentStyles = new String(".hp-phone-input{border:0;padding:0}");
componentStyles.__hash = "74b374e5521510e1";
